import React, { useEffect, useState } from "react";
import { apolloClient } from "../../..";
import { gql } from "@apollo/client";

import { getIntials, getName } from "../../../helper";
import ProfileWithName from "../../ListView/ListViewRows/ProfileWithName/ProfileWIthName";
import dateFormat from "dateformat";

const ActivityTab = (props) => {
  const isPopover = false;
  const [folderActivity, setFolderActivity] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const variables = {
      folderId: props.folderDetails.id,
    };
    apolloClient
      .query({
        query: gql`
          query FolderActivity($folderId: UUID!) {
            folderActivity(folderId: $folderId) {
              id
              user {
                id
                username
                firstName
                lastName
                profile {
                  image
                }
              }
              action {
                id
                name
              }
              createdTs
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        setFolderActivity([...result.data.folderActivity]);
      })
      .catch((e) => {
        setError("oops! soething went wrong try again later.");
      });
  }, [props.folderDetails]);
  return error ? (
    <div className="text-center mt-10">{error}</div>
  ) : (
    <div className="table-responsive mt-4 mb-6 activity-table">
      <table className="table table-hover">
        <thead className="table-borderless">
          <tr>
            <th scope="col">
              <label>Users</label>
            </th>
            <th scope="col">
              <label>Status</label>
            </th>
            <th>
              <label>Date & time</label>
            </th>
          </tr>
        </thead>
        <tbody>
          {folderActivity.map((uKey, index) => (
            <tr key={index}>
              <td>
                <ProfileWithName
                  sKey={uKey.id}
                  nameIntial={getIntials(uKey.user)}
                  personName={getName(uKey.user)}
                  profile={uKey?.user?.profile?.image}
                  isPopover={isPopover}
                />
              </td>
              <td>{uKey.action.name}</td>
              <td>{dateFormat(uKey.createdTs, "mmm dd, yyyy")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ActivityTab;
